import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The document head for one page.
 *
 * A single-page app has one `index.html`, so without this every route shares the
 * homepage's title and description — which is one page as far as a search engine
 * is concerned.
 *
 * The tags are *rendered*, not written into `document.head` by hand. React
 * hoists `<title>`, `<meta>` and `<link>` out of the tree into the head
 * wherever they appear, which means the same component works in the browser and
 * when the public pages are rendered to HTML at build time. An effect could
 * never do the second: there is no document to mutate, and the crawler that
 * matters most is the one that does not run scripts at all.
 */
export function PageHead({ title, description, canonical, noIndex, image, structuredData, }) {
    const blocks = structuredData
        ? Array.isArray(structuredData)
            ? structuredData
            : [structuredData]
        : [];
    return (_jsxs(_Fragment, { children: [_jsx("title", { children: title }), description && _jsx("meta", { name: "description", content: description }), canonical && _jsx("link", { rel: "canonical", href: canonical }), noIndex && _jsx("meta", { name: "robots", content: "noindex, nofollow" }), _jsx("meta", { property: "og:title", content: title }), description && _jsx("meta", { property: "og:description", content: description }), canonical && _jsx("meta", { property: "og:url", content: canonical }), _jsx("meta", { property: "og:type", content: "website" }), image && _jsx("meta", { property: "og:image", content: image }), _jsx("meta", { name: "twitter:card", content: image ? 'summary_large_image' : 'summary' }), _jsx("meta", { name: "twitter:title", content: title }), description && _jsx("meta", { name: "twitter:description", content: description }), image && _jsx("meta", { name: "twitter:image", content: image }), blocks.map((block, index) => (_jsx("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(block) } }, index)))] }));
}
/** Keeps one screen out of the index without repeating the rest of the head. */
export function NoIndex() {
    return _jsx("meta", { name: "robots", content: "noindex, nofollow" });
}
//# sourceMappingURL=PageHead.js.map